<template>
  <el-dialog
    :title="$t('deleteReportCustom.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div class="text-center">
      <p>{{ $t('deleteReportCustom.confirmDeleteReport') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('deleteReportCustom.cancel') }}</el-button>
      <el-button type="primary" @click="deleteReportCustom">
        {{ $t('deleteReportCustom.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteReportCustom } from '@/api/dev/reportCustomApi'

export default {
  name: 'DeleteReportCustom',
  data() {
    return {
      dialogVisible: false,
      deleteReportCustomInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteReportCustomInfo = { ...row }
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteReportCustomInfo = {}
    },
    async deleteReportCustom() {
      try {
        const res = await deleteReportCustom(this.deleteReportCustomInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('deleteReportCustom.deleteSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>